import * as yup from 'yup';

export const minOrderQuantityFormSchema = yup.object({
  enterprise: yup
    .number()
    .required('Enterprise is required'),
  plant: yup.string().required('Plant is required'),
  matnr: yup.string().required('MATNR is required'),
  minQuantity: yup
    .string()
    .required('Min Orderable Quantity is required')
    .matches(
      /^[0-9]*$/,
      'Invalid Minimum Orderable Quantity'
    )
    .max(9)
    .test(
      'greater-than-zero',
      'Quantity should be greater than 0',
      (value) => Number(value) > 0
    ),
});

export type TMinOrderQuantityFormData = yup.InferType<
  typeof minOrderQuantityFormSchema
>;
